import { Fragment } from 'react';

import useMeetSessionsDetail from './UseMeetSessionsDetail';

import OtsSessionsDetail from './OtsSessionsDetail';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import Headings from '@usas/ui-web/components/headings/Headings';

const MeetSessionsDetail = () => {
  const { otsMeetSessionsState, meetSessionsState, onSaveButtonClicked, onBackButtonClicked } = useMeetSessionsDetail();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{meetSessionsState.formState.meetSessionId > 0 ? 'Edit' : 'Add'} Session</Headings.H3>
        </div>
      </div>
      <OtsSessionsDetail />
      <div className='row usas-extra-top-margin'>
        <div className='col-xs-12'>
          {meetSessionsState?.errorState?.error && <p className={[global.ErrorMessage, global.Multiline].join(' ')}>{meetSessionsState?.errorState?.error}</p>}
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="button" onClick={onSaveButtonClicked}>Save</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onBackButtonClicked}>Back</SecondaryButton>
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={otsMeetSessionsState.isSaving} />
    </Fragment>
  );
};

export default MeetSessionsDetail;